/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Alert_Threshold_Unlimited_NoteInputs */



/**
* | output |
* | --- |
* | "Pool alerts will still fire; overage has no cap to alert against." |
*
* @param {Usage_Overage_Alert_Threshold_Unlimited_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_alert_threshold_unlimited_note = /** @type {((inputs?: Usage_Overage_Alert_Threshold_Unlimited_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Alert_Threshold_Unlimited_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pool-Benachrichtigungen werden weiterhin gesendet; Überschuss hat keine Obergrenze, vor der gewarnt werden könnte.")
	return /** @type {LocalizedString} */ ("Pool alerts will still fire; overage has no cap to alert against.")
});